import { Controller } from "@hotwired/stimulus";
import Tribute from "tributejs";

export default class extends Controller {
  static values = {
    lookupUrl: { type: String, default: "/autocomplete/users" }
  };

  connect() {
    this.tribute = new Tribute({
      trigger: "@",
      values: (text, cb) => {
        const url = new URL(this.lookupUrlValue, window.location.origin);
        if (text) url.searchParams.set("term", text);
        fetch(url, { headers: { Accept: "application/json" } })
          .then((r) => r.json())
          .then((list) => cb(list))
          .catch(() => cb([]));
      },
      lookup: "value",
      fillAttr: "value",
      selectTemplate: (item) => {
        const id = item.original.id;
        const label = item.original.value;
        return `@[${label}]`;
      },
      menuItemTemplate: (item) => {
        const v = item.original;
        return v.value;
      },
    });
    this.tribute.attach(this.element);
  }

  disconnect() {
    if (this.tribute) {
      try {
        this.tribute.detach(this.element);
      } catch (e) { }
      this.tribute = null;
    }
  }
}
